import { Component, OnInit, Input } from '@angular/core';
import { SpinnerService } from 'src/app/modules/spinner/spinner.service';
import { MatDialog } from '@angular/material';
import { MultimediaManagerComponent } from 'src/app/modules/multimedia-manager/multimedia-manager/multimedia-manager.component';
import { CatalogsService } from 'src/app/services/catalogs-services/catalogs-services/catalogs.service';
import { CatalogBasic } from 'src/app/models/catalogs-model/catalog.model';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { ImageDialogComponent } from '../../shared-components/image-dialog/image-dialog.component';

@Component({
  selector: 'app-catalogs-catalog-photo-editor-card',
  templateUrl: './catalogs-catalog-photo-editor-card.component.html',
  styleUrls: ['./catalogs-catalog-photo-editor-card.component.scss']
})
export class CatalogsCatalogPhotoEditorCardComponent implements OnInit {

  @Input() catalog: CatalogBasic;
  @Input() title: string;
  @Input() width: string;
  @Input() height: string;
  showSpinner: boolean;

  constructor(private spinnerService: SpinnerService,
              private dialog: MatDialog,
              private snackbarService: SnackBarService,
              private catalogsService: CatalogsService) { }

  ngOnInit() {
    this.showSpinner = false;
  }

  public updateImageCatalog(imageUrl) {
    this.showSpinner = true;
    this.spinnerService.show('catalog-image-spinner');
    this.catalogsService.updateCatalogImage(this.catalog.InternalId, imageUrl).subscribe(
      (res) => {
        this.catalogsService.refreshCatalog();
        this.showSpinner = false;
        this.spinnerService.hide('product-image-spinner');
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.catalogsService.refreshCatalog();
        this.showSpinner = false;
        this.spinnerService.hide('catalog-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public deleteAsset() {
    this.showSpinner = true;
    this.spinnerService.show('catalog-image-spinner');
    this.catalogsService.updateCatalogImage(this.catalog.InternalId, null).subscribe(
      (res) => {
        this.catalogsService.refreshCatalog();
        this.showSpinner = false;
        this.spinnerService.hide('product-image-spinner');
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.catalogsService.refreshCatalogs();
        this.showSpinner = false;
        this.spinnerService.hide('catalogs-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public zoom() {
    const dialogRef = this.dialog.open(ImageDialogComponent, { data: { image: this.catalog.Image, info: { title: this.title, subtitle: this.width + 'x' + this.height }}});
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        if (res === 'upload') {
          this.uploadPhotoClicker();
        } else if (res === 'delete') {
          this.deleteAsset();
        }
      }
    });
  }

  public uploadPhotoClicker() {
    const dialogRef = this.dialog.open(MultimediaManagerComponent, { data: { multi: false, cropper: { width: 250, height: 250 } } });
    dialogRef.beforeClosed().subscribe(
      (result) => {
        if (result) {
          this.updateImageCatalog(result[0].Url);
        }

      }
    );
  }
}
